module.exports = __webpack_public_path__ + "img/b.574d0f4d.jpg";